// extracted by mini-css-extract-plugin
module.exports = {"Panel":"Panel_Panel__2M3LQ","content":"Panel_content__1aviU","note":"Panel_note__PU2jI"};